export default "__VITE_ASSET__Ce0Z_pk5__"